<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFirstAid } from '@fortawesome/free-solid-svg-icons';

import config from '@/config/config';

library.add( faFirstAid );

export default {
  name: 'ComponentsCourseSidebar',
  computed: {
    ...mapState(config.app, [
      'course',
      'currentCourse',
    ]),
    logo() {
      return get(this, 'course.cover.url', null);
    },
    title() {
      return get(this, 'course.title', '');
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: mapMutations(config.app, [
    'setCurrentCourse',
  ]),
};
</script>
<template>
    <div id="course-sidebar">
        <img :src="logo" alt="course logo" class="img-fluid" />
        <ul>
            <li>
                <font-awesome-icon icon="first-aid" class="mr-2" />
                <h5 class="flex-1">{{ title }}</h5>
            </li>
            <li>
                <a @click="setCurrentCourse(flow.start)" :class="{active: flow.start === currentCourse}">
                    Informacje o kursie
                </a>
            </li>
            <li>
                <a @click="setCurrentCourse(flow.video)" :class="{active: flow.start !== currentCourse}">
                    Zawartość kursu
                </a>
            </li>
        </ul>
    </div>
</template>
